import type Store from "@ember-data/store";
import type { DmpAdapter } from "parog-web/cnam-adapters/dmp-adapter";
import type { InsiAdapter } from "parog-web/cnam-adapters/insi-adapter";
import { InsStatus } from "parog-web/cnam/types";

import type Patient from "parog-web/models/patient";
import { State } from "./abstract/cnam-context";
import type { AuthenticationContext } from "./authentication-context";
import InsWithConfirmationRetrievalContext from "./ins-with-confirmation-retrieval-context";

export default class InsWithConfirmationAndSuccessRetrievalContext extends InsWithConfirmationRetrievalContext {
  constructor(
    cnamAdapterName: string,
    patient: Patient,
    authenticationContext: AuthenticationContext,
    insiAdapter: InsiAdapter,
    dmpAdapter: DmpAdapter,
    store: Store,
    requestManager,
    onSuccess?: () => Promise<void>
  ) {
    super(
      cnamAdapterName,
      patient,
      authenticationContext,
      insiAdapter,
      dmpAdapter,
      store,
      requestManager,
      "insi",
      onSuccess
    );

    this.states = [
      ...this.states,
      new State(
        "show-success",
        (): Promise<boolean> => {
          return Promise.resolve(
            (this.patient.insStatus == InsStatus.Qualified ||
              this.patient.insStatus == InsStatus.Recovered) &&
              !this.isInsProcessNeeded &&
              this.isIdentitySaved
          );
        },
        async (): Promise<void> => {
          await this.store
            .createRecord("cnam-process-ended-journal-event", {
              timedTransactions: this.timedTransactions,
              occurredAt: new Date(),
              patient: this.patient,
              cnamProcessStartedJournalEvent:
                this.cnamProcessStartedJournalEvent
            })
            .save();
          this.successKey = "ins";
        }
      )
    ];
  }

  override reset() {
    super.reset();
    this.successKey = undefined;
  }
}
